/** Caché de imágenes del lienzo: carga perezosa y aviso para redibujar al terminar. */

const cache = new Map<string, HTMLImageElement>()
const failed = new Set<string>()
let onLoaded: (() => void) | null = null

export function setImageLoadedCallback(cb: () => void): void {
  onLoaded = cb
}

export function getImage(src: string): HTMLImageElement | null {
  const cached = cache.get(src)
  if (cached) return cached.complete && cached.naturalWidth > 0 ? cached : null
  if (failed.has(src)) return null

  const img = new Image()
  img.crossOrigin = 'anonymous'
  img.decoding = 'async'
  img.onload = () => onLoaded?.()
  img.onerror = () => {
    failed.add(src)
    cache.delete(src)
  }
  img.src = src
  cache.set(src, img)
  return null
}

/** Espera a que todas las imágenes de una lista estén listas (para exportar). */
export async function preloadImages(sources: string[]): Promise<void> {
  await Promise.all(
    sources.map(
      (src) =>
        new Promise<void>((resolve) => {
          if (getImage(src)) return resolve()
          const img = cache.get(src)
          if (!img) return resolve()
          img.addEventListener('load', () => resolve(), { once: true })
          img.addEventListener('error', () => resolve(), { once: true })
        }),
    ),
  )
}
